import {connect} from 'react-redux';
import {
  userStagsSelector,
  fetchingUserStagsSelector,
  userCreatedStagsSelector,
} from '../../../reducers';
import MyStags from './component';

const mapStateToProps = (state) => {
  return {
    fetching: fetchingUserStagsSelector(state),
    stags: userStagsSelector(state),
    createdStags: userCreatedStagsSelector(state),
  }
};

export default connect(mapStateToProps)(MyStags);



// WEBPACK FOOTER //
// ./src/component/organisms/MyStags/index.js